/** Human-readable message from an axios/Nest error, with a fallback. */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const err = error as { response?: { data?: { message?: string | string[] } }; message?: string };
  const apiMessage = err?.response?.data?.message;
  return Array.isArray(apiMessage) ? apiMessage.join(", ") : apiMessage || err?.message || fallback;
}

/** Browser-local calendar date (YYYY-MM-DD), not the UTC date `toISOString()` would give. */
export function todayLocalYmd(now: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
